import React, { createContext, useContext, useState } from "react";

export const StepperContext = createContext(null);

export const useStepperContext = () => {
  const context = useContext(StepperContext);
  if (!context) {
    throw new Error("useStepperContext must be used within a StepperProvider");
  }
  return context;
};

export const StepperProvider = ({ children, steps }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [stepData, setStepData] = useState({});

  const goToNextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const goToPrevStep = () => {
    if (currentStep > 0) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const updateStepData = (key, value) => {
    setStepData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const value = {
    currentStep,
    setCurrentStep,
    steps,
    goToNextStep,
    goToPrevStep,
    isFirstStep: currentStep === 0,
    isLastStep: currentStep === steps.length - 1,
    stepData,
    updateStepData,
  };

  return (
    <StepperContext.Provider value={value}>{children}</StepperContext.Provider>
  );
};
